import { z } from 'zod';
import { msg } from '~/utils/validation';

export const schema = z.object({
  book: z.string({ message: msg.required }).transform(n => Number(n)),
  status: z.enum(['active', 'warned', 'suspended', 'unknown'], { message: msg.required }),
  person: z.tuple([z.string(), z.number()], { message: msg.required }),
});

export type Schema = z.infer<typeof schema>;
